const SuccessPayment = () => {
    return(
        <div className="success-payment">
            <img src="/static/success.png" alt="success payment" />
        </div>
    )
}

export default SuccessPayment;